module.exports = __webpack_public_path__ + "static/media/lorrygif.b04e20c2.gif";